import { FC, useEffect, useState } from "react";
import Errors from "../../../components/errors/Errors";
import Listview from "../../../components/listview/Listview";
import { DefaultPagination, getPagination, Pagination } from "../../../components/listview/Pagination";
import useAbortController from "../../../hooks/useAbortController";
import { Members } from "../../../listsSettings/members";
import { ErrorCode, IListviewField, SearchResult, UserPermissions } from "../../../services/types";
import { getUserPermissions } from "../../../services/webapi";
import * as Fields from "./Fields";
import { Member } from "./types";
import { getMemberFilters, getMembers } from "./webapi";

const AllItems: FC = () => {
  const listviewId = "members-all-items";
  const fields: IListviewField<Member>[] = [
    Fields.name,
    Fields.memberNumber,
    Fields.city,
    Fields.street,
    Fields.phone,
    Fields.email,
    Fields.isMember,
    Fields.type,
    Fields.status,
    Fields.companyType,
  ];

  const [members, setMembers] = useState<SearchResult<Member> | null>(null);

  const [abortController, resetAbortController] = useAbortController();
  const [errorCode, setErrorCode] = useState<ErrorCode>();
  const [permissions, setPermissions] = useState<UserPermissions>();

  const pagination = getPagination(listviewId) || {
    ...DefaultPagination,
  };

  useEffect(() => {
    loadMembers(pagination);

    return () => {
      abortController && abortController.abort();
    };
  }, []);

  const loadMembers = async (pagination: Pagination) => {
    const abortController = resetAbortController();
    const permissions = await getUserPermissions(
      Members.Lists.Members.InternalName,
      Members.InternalName,
      abortController.signal,
    );

    if (!abortController.signal.aborted) {
      setPermissions(permissions);
      const canRead = permissions.schemaPermission && permissions.listPermissions.includes("read-all");
      !canRead && setErrorCode(403);
      if (canRead) {
        const result = await getMembers(pagination, abortController.signal);
        if (!abortController.signal.aborted) {
          result.data && setMembers(result.data);
          result.error && setErrorCode(result.error.code);
        }
      }
    }
  };

  return (
    <>
      {permissions &&
        (!errorCode ? (
          <Listview
            id={listviewId}
            viewProperties={{
              schema: Members.InternalName,
              list: Members.Lists.Members.InternalName,
              name: "all_items",
              setListAndPage: true,
            }}
            fields={fields}
            reload={loadMembers}
            searchResult={members}
            getFilters={getMemberFilters}
            pagination={pagination}
            updateItems={(items) =>
              members &&
              setMembers({
                ...members,
                items: items,
              })
            }
          />
        ) : (
          errorCode && <Errors errorCode={errorCode} />
        ))}
    </>
  );
};

export default AllItems;
